import * as React from "react"
import type { SVGProps } from "react"
const SvgRecommendationIncomingOnly = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M17.87 9.12a7.8 7.8 0 0 0-6.1-.84 7.7 7.7 0 0 0-4.87 3.74l-.09.15-.33-1.23a1 1 0 0 0-.46-.59 1 1 0 0 0-.75-.1 1 1 0 0 0-.59.46 1 1 0 0 0-.1.74l.94 3.56a.96.96 0 0 0 1.22.7l3.55-.96a1 1 0 0 0 .59-.46q.2-.37.1-.75a1 1 0 0 0-.46-.59 1 1 0 0 0-.75-.1l-1.22.32.08-.15a5.8 5.8 0 0 1 3.65-2.8 5.9 5.9 0 0 1 5.82 1.6q.3.32.7.38t.77-.17a.9.9 0 0 0 .17-1.4q-.4-.46-.87-.84a8 8 0 0 0-1-.67" />
  </svg>
)
export default SvgRecommendationIncomingOnly
